import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useMediaQuery } from '@material-ui/core';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

function TrustedCustomers({ title }) {
  const { t } = useTranslation('static_pages');
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <StyledContainer>
      <Typography
        textAlign="center"
        variant={mobile ? 'h4' : 'h3'}
        xs={{ lineHeight: 1.5 }}
        px={{ xs: 4, sm: 10, md: 0 }}
        component="p"
      >
        {title ? t(title) : t('baseHero.trustedBy')}
      </Typography>
      <Box
        pt={3}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap={{ xs: 'wrap', md: 'nowrap' }}
        width={{ xs: 400, md: '100%' }}
        mx="auto"
      >
        <Box
          mx={{ xs: 4, lg: 5 }}
          my={2}
          width={{ xs: 74, md: 127 }}
          height={{ xs: 14, md: 20 }}
          position="relative"
        >
          <CustomerLogo
            alt="The logo of Barmer"
            src="/artifacts/images/homepage/trust-customer-icons/barmer.webp"
            layout="responsive"
            width="127"
            height="20"
          />
        </Box>
        <Box
          mx={{ xs: 4, lg: 5 }}
          my={2}
          width={{ xs: 35, md: 46 }}
          height={{ xs: 35, md: 46 }}
          position="relative"
        >
          <CustomerLogo
            alt="The logo of Dell"
            src="/artifacts/images/homepage/trust-customer-icons/dell.webp"
            layout="responsive"
            width="46"
            height="46"
          />
        </Box>
        <Box
          mx={{ xs: 4, lg: 5 }}
          my={2}
          width={{ xs: 67, md: 103 }}
          height={{ xs: 12, md: 25 }}
          position="relative"
        >
          <CustomerLogo
            alt="The logo of Infarm"
            src="/artifacts/images/homepage/trust-customer-icons/infarm.webp"
            layout="responsive"
            width="103"
            height="25"
          />
        </Box>
        <Box
          mx={{ xs: 4, lg: 5 }}
          my={2}
          width={62}
          height={{ xs: 13, md: 25 }}
          position="relative"
        >
          <CustomerLogo
            alt="The logo of Ebay"
            src="/artifacts/images/homepage/trust-customer-icons/ebay.webp"
            layout="responsive"
            width="62"
            height="25"
          />
        </Box>
        <Box
          mx={{ xs: 4, lg: 5 }}
          my={2}
          width={{ xs: 44, md: 66 }}
          height={{ xs: 22, md: 32 }}
          position="relative"
        >
          <CustomerLogo
            alt="The logo of Hellofresh"
            src="/artifacts/images/homepage/trust-customer-icons/hellofresh.webp"
            layout="responsive"
            width="66"
            height="32"
          />
        </Box>
        <Box
          mx={{ xs: 4, lg: 5 }}
          my={2}
          width={{ xs: 47, md: 56 }}
          height={{ xs: 9, md: 20 }}
          position="relative"
        >
          <CustomerLogo
            alt="The logo of Audi"
            src="/artifacts/images/homepage/trust-customer-icons/audi.webp"
            layout="responsive"
            width="56"
            height="20"
          />
        </Box>
      </Box>
    </StyledContainer>
  );
}

const CustomerLogo = styled(Image)`
  margin: ${(props) => props.theme.spacing(0, 10)};
`;

const StyledContainer = styled.div`
  padding: ${(props) => props.theme.spacing(4, 0)};
  background: rgba(248, 248, 248, 1);
`;

export default TrustedCustomers;
